
/**
 * Created by CCristi on 11/14/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalErrorStrategy = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractStrategy2 = require('./AbstractStrategy');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let InternalErrorStrategy = exports.InternalErrorStrategy = function (_AbstractStrategy) {
  _inherits(InternalErrorStrategy, _AbstractStrategy);

  function InternalErrorStrategy() {
    _classCallCheck(this, InternalErrorStrategy);

    return _possibleConstructorReturn(this, (InternalErrorStrategy.__proto__ || Object.getPrototypeOf(InternalErrorStrategy)).call(this));
  }

  /**
   * @returns {Boolean}
   */


  _createClass(InternalErrorStrategy, [{
    key: 'onSuccess',
    value: function onSuccess() {
      return false;
    }

    /**
     * @param {Response} response
     * @returns {Boolean}
     */

  }, {
    key: 'onError',
    value: function onError(response) {
      return response.statusCode >= 500;
    }
  }]);

  return InternalErrorStrategy;
}(_AbstractStrategy2.AbstractStrategy);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/RetryStrategy/InternalErrorStrategy.js
// module id = 99
// module chunks = 0